<template>
  <div class="index">
    <el-container style="width: 100%">
      <!-- 左侧菜单 -->
      <v-aside
        :style="
          collapse
            ? 'width: 60px;'
            : this.$i18n.locale == 'en_US'
            ? 'width: 200px;'
            : this.$i18n.locale == 'ja_JP'
            ? 'width: 263px;'
            : 'width: 182px;'
        "
      ></v-aside>
      <!-- 右侧内容 -->
      <el-container style="width: 100%; display: flow-root; position: relative">
        <!-- 右侧内容-头部导航 -->
        <v-header v-on:password="password"></v-header>
        <!-- 右侧内容-头部Tab导航 -->
        <transition name="tags" mode="out-in">
          <v-tags v-show="tagsTop"></v-tags>
        </transition>
        <!-- 右侧内容-密码修改组件 -->
        <v-password :dialogPassword="dialogPassword" v-on:closePasswordDialog="passwordDialog"></v-password>
        <!-- 右侧内容-主内容 -->
        <el-main style="height: calc(100vh - 110px);">
          <div style="width: 100%; height: 100%; display: flow-root; background-color: white; border-radius: 5px">
            <vue-scroll style="border-radius: 10px">
              <transition name="move-main" mode="out-in">
                <keep-alive :include="tagList">
                  <router-view></router-view>
                </keep-alive>
              </transition>
            </vue-scroll>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import vPassword from "@/components/Password";
  import vTags from "@/components/Tags";
  import vAside from "@/components/sidebar/Aside";
  import vHeader from "@/components/Header";
  import Intercom from "@intercom/messenger-js-sdk";

  export default {
    name: "Index",
    data() {
      return {
        dialogPassword: false,
        tag: true
      };
    },
    computed: {
      ...mapGetters(["uid", "userName", "nickName"]),
      collapse() {
        return this.$store.state.collapse;
      },
      tagList() {
        return this.$store.state.tagList;
      },
      tagsTop() {
        return this.$store.state.tagsTop;
      }
    },
    components: {
      vPassword,
      vTags,
      vAside,
      vHeader
    },
    mounted() {
      const that = this;
      window.onresize = () => {
        if (document.body.clientWidth <= 1200) {
          that.$store.dispatch("collapse", true);
        } else {
          that.$store.dispatch("collapse", false);
        }
      };

      // Fetch machine numbers and initialize Intercom with custom attributes
      this.initializeIntercomWithMachines();
    },
    methods: {
      // Initialize Intercom with machine numbers
      async initializeIntercomWithMachines() {
        try {
          // Fetch all user machines
          const response = await this.$api.request(
            this.$url.UserMachine.userList,
            this.$method.get,
            {}
          );

          let machineNumbers = [];

          // Handle different response structures
          let machinesArray = [];
          if (response.code === 0 && response.data) {
            // Check if response.data is an array
            if (Array.isArray(response.data)) {
              machinesArray = response.data;
            }
            // Check if response.data has a records property (paginated response)
            else if (response.data.records && Array.isArray(response.data.records)) {
              machinesArray = response.data.records;
            }
            // Check if response.data has a list property
            else if (response.data.list && Array.isArray(response.data.list)) {
              machinesArray = response.data.list;
            }
            // If response.data is an object with array-like structure
            else if (response.data.data && Array.isArray(response.data.data)) {
              machinesArray = response.data.data;
            }

            if (machinesArray.length > 0) {
              // Extract all equipment numbers from the response
              machineNumbers = machinesArray
                .map(machine => {
                  // Try different possible property names
                  return machine.equipmentNo || machine.equipment_id || machine.machineNo || machine.id || null;
                })
                .filter(Boolean); // Filter out any null/undefined values
            }
          }

          // Send all machines - use comma without space to save characters
          const machineIdsToSend = machineNumbers.length > 0 ? machineNumbers.join(",") : "";

          // Initialize Intercom with custom attributes
          // Note: Intercom normalizes custom attribute keys
          // Try multiple key formats to match Intercom's expected format
          const intercomSettings = {
            app_id: "kx28g8jk",
            user_id: this.uid,
            email: this.userName,
            name: this.nickName,
            // Custom user attributes - Company Name and Machine Numbers
            company_name: "VapeTM",
            // Try the most common format (lowercase with spaces)
            "vapetm machine ids": machineIdsToSend
          };

          // Initialize Intercom
          Intercom(intercomSettings);

          // Wait a moment for Intercom to load, then boot it explicitly
          setTimeout(() => {
            if (window.Intercom) {
              window.Intercom('boot', intercomSettings);

              // Update Intercom with attributes again to ensure they're set
              setTimeout(() => {
                const updateData = {
                  company_name: "VapeTM",
                  "vapetm machine ids": machineIdsToSend
                };

                window.Intercom('update', updateData);
              }, 1000);
            }
          }, 500);

        } catch (error) {
          // Fallback: Initialize Intercom without machine numbers
          const fallbackSettings = {
            app_id: "kx28g8jk",
            user_id: this.uid,
            email: this.userName,
            name: this.nickName,
            company_name: "VapeTM",
            "vapetm machine ids": ""
          };

          Intercom(fallbackSettings);

          setTimeout(() => {
            if (window.Intercom) {
              window.Intercom('boot', fallbackSettings);
            }
          }, 500);
        }
      },

      passwordDialog(password) {
        this.dialogPassword = password;
      },
      password(password) {
        this.dialogPassword = password;
      }
    },
    created() {
      if (!this.$store.state.menuList || this.$store.state.menuList.length <= 0) {
        this.$router.push("/login");
      }
      if (this.$route.path === "" || this.$route.path === "/") {
        this.$router.push("/main");
      }
      if (document.body.clientWidth <= 1200) {
        this.$store.dispatch("collapse", true);
      }
    }
  };
</script>

<style lang="scss">
  @import "../assets/scss/index";

  .move-main-enter-active,
  .move-main-leave-active {
    transition: all 0.5s;
  }

  .move-main-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .move-main-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }

  .tags-enter-active,
  .tags-leave-active {
    transition: all 0.5s;
  }

  .tags-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .tags-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }

  .__view {
    width: 100% !important;
  }
  .index {
    display: flow-root;
    width: 100%;
    height: 100%;
  }
  .sys-header {
    position: absolute;
    width: 100%;
    height: 60px;
    display: flow-root;
  }
  .rights {
    display: flow-root;
    width: 90%;
  }
</style>
